<template>
  <div class="app-centered-form" v-if="canManage">
    <app-loading :visible="loading" />
    <form class="md-layout from-box" name="file-add" action=""
      v-on:submit.prevent="onFileSubmit"
      v-if="showFileForm">
      <md-card class="md-layout-item md-size-250 md-small-size-250">
        <file-form-fields v-model="file.fileName" ref="formFields" :error-message-file="validationErrorFile"/>
        <md-card-actions>
          <md-button class="md-raised md-primary" type="submit" v-lang.add :disabled="file.fileName === ''"></md-button>
          <md-button class="md-raised" v-on:click="goBack">
            <span v-lang.back></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
    <form class="md-layout from-box" v-on:submit.prevent="sendDocument" v-if="showDocumentForm">
      <md-card class="md-layout-item md-size-250 md-small-size-250">
        <document-form-fields v-model="file" :error-message="validationError"/>
        <md-card-actions>
          <md-button class="md-raised md-primary" v-lang.add type="submit"></md-button>
          <md-button class="md-raised" v-on:click="showForm">
            <span v-lang.back></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import FileFormFields from './FileFormFields.vue'
import DocumentFormFields from './DocumentFormFields.vue'
import DocumentService from '@/common/services/document'
import AppLoading from '@/components/ui/AppLoading.vue'
import HasLoading from '@/mixins/HasLoading.mixin'
import Auth from '@//common/auth/index.js'
import ValidateMixin from '@/components/documents/Validate.mixin'

export default {
  name: 'DocumentAddForm',
  components: {
    FileFormFields,
    DocumentFormFields,
    AppLoading
  },
  mixins: [
    HasLoading,
    ValidateMixin
  ],
  data () {
    return {
      required: null,
      hasMessages: false,
      /** @type {SvpDocumentFile} */
      file: this.getEmptyFile(),
      showDocumentForm: false,
      showFileForm: true,
      documentNameError: false,
      validationError: '',
      validationErrorFile: '',
      canManage: Auth.CanManageDocs()
    }
  },
  watch: {
    file: {
      deep: true,
      handler () {
        this.hideErrors()
      }
    }
  },
  methods: {
    onFileSubmit (e) {
      const file = this.$refs.formFields.getFiles()[0]
      const validationErrors = this.validateFile(file)

      if (validationErrors.length === 0) {
        this.startAppLoading()
        DocumentService.Files(file)
          .then(response => {
            this.file.id = response.data.id
          })
          .then(response => {
            this.showDocumentForm = true
            this.showFileForm = false
            this.finishAppLoading()
          })
          .catch(error => {
            if (error.response.status === 400) {
              this.validationError = error.response.data.message
            } else {
              this.$httpError.handle.call(this, error)
            }
          })
      } else {
        this.validationErrorFile = this.$errorsToString(validationErrors)
      }
    },
    sendDocument () {
      const row = {
        fileId: this.file.id,
        name: this.file.name
      }
      const validationErrors = this.validate(this.file)

      if (validationErrors.length === 0) {
        this.startAppLoading()
        DocumentService.Documents(row)
          .then(() => {
            this.file = this.getEmptyFile()
            this.showForm()
            this.$success(this.translate('successfulAddingDocument'), 5000)
            this.goBack()
          })
          .catch(error => {
            if (error.response.status === 400) {
              this.validationError = error.response.data.message
            } else {
              this.$httpError.handle.call(this, error)
            }
          })
          .then(() => {
            this.finishAppLoading()
          })
      } else {
        this.validationError = this.$errorsToString(validationErrors)
      }
    },
    hideErrors () {
      this.validationError = ''
      this.validationErrorFile = ''
    },
    showForm () {
      this.showDocumentForm = false
      this.showFileForm = true
    },
    getBackQuery () {
      return this.$route.query
    },
    goBack () {
      this.$router.push({
        name: 'DocumentListComponent',
        query: this.getBackQuery()
      })
    },
    getEmptyFile () {
      return {
        id: '',
        fileName: '',
        name: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/AddForm.vue